import React, { useState, useEffect } from "react";
import axios from "axios";
import "./ItemWiseReports.css"; // Ensure the CSS matches your file structure
import { useAuth } from "../AuthContext";

const itemPairs = [
  {
    id: 1,
    item1: [
      "SITAFIX-50 TAB 10*7",
      "SITAFIX-M 50/500 TAB 10*15",
      "SITAWISE-100 TAB 10*7",
      "SITAWISE-50 TAB 10*7",
      "SITAWISE-D 100/10 TAB 10*10",
      "SITAWISE-DM 100/10/1000 TAB 10*10",
      "SITAWISE-DM 100/10/500 TAB 10*10",
      "SITAWISE-M 50/1000 TAB 10*15",
      "SITAWISE-M 50/500 TAB 10*15",
      "SITAWISE-M-XR 100/500 TAB 10*10",
      "SITAWISE-MG 50/1000/2 TAB 10*10",
      "SITAWISE-MP 100/500/15 SR TAB 10*10",
    ],
    item2: [],
    genericName1: "Sitagliptin Range",
    genericName2: "",
  },
  {
    id: 2,
    item1: [
      "DAPACAM-10 TAB (10*14) 10*14",
      "DAPACAM-5 TAB (10*14) 10*14",
      "DAPACAM-M 10/1000 10*10",
      "DAPACAM-M 10/500 10*10",
      "DAPACAM-M 5/1000 TAB 10*10",
      "DAPACAM-M 5/500 TAB 10*10",
      "DAPACAM-MG 10/1000/2 10*10",
      "DAPACAM-MG 10/500/2 10*10",
      "DAPACAM-MV 10/100/1000 TAB 10*10",
      "DAPACAM-MV 10/100/500 TAB 10*10",
      "DAPACAM-T 10/20 TAB 10*10",
      "DAPACAM-V 10/100 SR TAB 10*10",
      "DAPAVATE-10 TAB 10*14",
      "DAPAVATE-M 10/500 TAB 10*10",
      "DAPAWISE-10 TAB 10*14",
      "DAPAWISE-5 TAB 10*14",
      "DAPAWISE-M 10/500 TAB 10*10",
    ],
    item2: [],
    genericName1: "Dapagliflozin Range",
    genericName2: "",
  },
  {
    id: 3,
    item1: [
      "CEFOB-125 DRY SYRUP(WATER) SINGLE",
      "CEFOB-1500 INJ. SINGLE",
      "CEFOB-250 TAB 10*10",
      "CEFOB-500 TAB 10*10",
      "CEFOB-CV 10*1*10",
      "CEFOB-CV 250 TABLET 10*1*10",
      "CEFOB-CV DRY SYRUP(WATER) 30ML",
      "CEFUCAM-125 DRY SYP 30ML",
      "CEFUCAM-250 TAB 10*1*10",
      "CEFUCAM-500 TAB 10*10",
      "CEFUCAM-CV TABLET 10*1*10",
      "CEFUMUST-250 TAB 10*1*10",
      "CEFUMUST-500 TAB 10*1*10",
      "CEFUREM-125 D/S (WATER) 30ML",
      "CEFUREM-250 TAB 10*1*10",
      "CEFUREM-500 TAB 10*1*10",
      "CEFUREM-CV TAB 10*1*10",
      "PYROCEF-250 TAB 10*1*10",
      "PYROCEF-500 TAB 10*1*10",
    ],
    item2: [],
    genericName1: "Cefuroxime Range",
    genericName2: "",
  },
];

const ItemWiseReports = () => {
  const { mobile } = useAuth();
  const [popupMessage, setPopupMessage] = useState("");
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const [reports, setReports] = useState({});
  const [searchQuery, setSearchQuery] = useState(""); // State to manage the search query
  const [expandedReports, setExpandedReports] = useState(new Set());
  const [suggestions, setSuggestions] = useState([]);

  const showPopupMessage = (message) => {
    setPopupMessage(message);
    setIsPopupVisible(true);
    setTimeout(() => {
      setIsPopupVisible(false);
    }, 4000); // Hide the popup after 3 seconds
  };

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/api/employee/customers-area-wise?mobile=${mobile}`
      )
      .then((response) => {
        const allCustomers = response.data;
        const newReports = {};

        itemPairs.forEach((pair) => {
          if (pair.item2.length === 0) {
            newReports[pair.id] = allCustomers
              .filter((customer) => {
                const customerItems = JSON.parse(customer.items_taking);
                return pair.item1.some((item) => customerItems.includes(item));
              })
              .sort((a, b) => b.Avg_Sales - a.Avg_Sales)
              .reduce((unique, customer) => {
                if (!unique.some((u) => u.Party_Name === customer.Party_Name)) {
                  unique.push(customer);
                }
                return unique;
              }, []);
          } else {
            newReports[pair.id] = allCustomers
              .filter((customer) => {
                const customerItems = JSON.parse(customer.items_taking);
                const takesItem1 = pair.item1.some((item) =>
                  customerItems.includes(item)
                );
                const takesItem2 = pair.item2.some((item) =>
                  customerItems.includes(item)
                );
                return takesItem1 && !takesItem2;
              })
              .sort((a, b) => b.Avg_Sales - a.Avg_Sales)
              .reduce((unique, customer) => {
                if (!unique.some((u) => u.Party_Name === customer.Party_Name)) {
                  unique.push(customer);
                }
                return unique;
              }, []);
          }
        });

        setReports(newReports);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setError("Failed to fetch data");
        setIsLoading(false);
      });
  }, [mobile]);

  const toggleReport = (id, event) => {
    event.stopPropagation();
    const newExpandedReports = new Set(expandedReports);
    if (newExpandedReports.has(id)) {
      newExpandedReports.delete(id);
    } else {
      newExpandedReports.add(id);
    }
    setExpandedReports(newExpandedReports);
    console.log(expandedReports);
  };

  const copyMessageToClipboard = (customer, pair) => {
    const message =
      `*NOT TAKING ${pair.genericName2}*\n\n` +
      `Hi,\n\n` +
      `${customer.Party_Name}\n\n` +
      `This side ${customer.Employee} from ${
        customer.Company || "Team Trumac"
      }, Panchkula.\n\n` +
      `Hope you are doing good. We have observed that you are taking ${pair.genericName1} from us but *NOT TAKING* ${pair.genericName2}.\n\nWe are sure that if you launch ${pair.genericName2} in your area then you will definitely get good sales.\n\nSo we request you to kindly give order for this product.\n\n` +
      `Regards,\n` +
      `${customer.Employee}, ${customer.Company || "Your Company"}\n` +
      `${mobile}`;

    navigator.clipboard.writeText(message).then(
      () => {
        showPopupMessage(`Message Copied to Clipboard..`);
      },
      (err) => {
        console.error("Could not copy text: ", err);
      }
    );
  };

  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    const lowerCaseQuery = query.toLowerCase();

    if (query === "") {
      setSuggestions([]);
      setExpandedReports(new Set()); // Clear expanded reports when search query is empty
    } else {
      const allCustomers = Object.values(reports).flat();
      const filteredSuggestions = allCustomers
        .map((customer) => customer.Party_Name)
        .filter((name) => name.toLowerCase().includes(lowerCaseQuery));
      setSuggestions(filteredSuggestions.slice(0, 10)); // Limit to top 10 suggestions
    }
  };

  const handleSuggestionClick = (suggestion) => {
    setSearchQuery(suggestion);
    setSuggestions([]);

    const newExpandedReports = new Set();
    // Iterate over all pairs to find which reports should be expanded
    itemPairs.forEach((pair) => {
      const customers = reports[pair.id] || [];
      // Check if any customer in this report matches the suggestion
      const matches = customers.some(
        (customer) =>
          customer.Party_Name.toLowerCase() === suggestion.toLowerCase()
      );
      if (matches) {
        newExpandedReports.add(pair.id);
      }
    });
    // console.log(
    //   "New Expanded Reports before setting:",
    //   Array.from(newExpandedReports)
    // );
    setExpandedReports((prevState) => {
      return new Set(newExpandedReports);
    });
  };

  //   useEffect(() => {
  //     console.log("Updated Expanded Reports:", Array.from(expandedReports));
  //   }, [expandedReports]);

  const filterReports = (customers) => {
    if (!searchQuery) return customers;
    return customers.filter((customer) =>
      customer.Party_Name.toLowerCase().includes(searchQuery.toLowerCase())
    );
  };

  if (isLoading) return <div className="center-message">Loading...</div>;
  if (error) return <div className="center-message">{error}</div>;

  return (
    <div className="item-wise-page-container">
      <div className="customers-container">
        <h1>Item Wise Reports</h1>
        <input
          type="text"
          className="search-bar"
          placeholder="Search for a customer..."
          value={searchQuery}
          onChange={handleSearchChange}
        />
        {suggestions.length > 0 && (
          <ul className="search-suggestions">
            {suggestions.map((suggestion, index) => (
              <li key={index} onClick={() => handleSuggestionClick(suggestion)}>
                {suggestion}
              </li>
            ))}
          </ul>
        )}
        <div className="reports-container">
          {itemPairs.map((pair) => (
            <div
              key={pair.id}
              className="report-card"
              onClick={(e) => {
                e.stopPropagation(); // Stop propagation to prevent the page-container click
                toggleReport(pair.id, e);
              }}
            >
              <h2>
                Customers Taking -- ({pair.genericName1})
                {pair.genericName2 && (
                  <> but not Taking -- ({pair.genericName2})</>
                )}
                <span
                  className="icon-container"
                  onClick={(e) => {
                    e.stopPropagation(); // Stop propagation to prevent the page-container click
                    toggleReport(pair.id, e);
                  }}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{
                      transform: expandedReports.has(pair.id)
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                    }}
                  >
                    <path
                      d="M6 9L12 15L18 9"
                      stroke="#333"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </h2>
              {expandedReports.has(pair.id) && (
                <div className="report-details">
                  <div className="customers-list">
                    {reports[pair.id] && reports[pair.id].length > 0 ? (
                      filterReports(reports[pair.id])
                        .sort((a, b) => b.Avg_Sales - a.Avg_Sales)
                        .map((customer) => (
                          <div
                            key={customer.customer_sale_data_id}
                            className="customer-card"
                            onClick={(e) => e.stopPropagation()} // Stop propagation to keep the report expanded
                          >
                            <div className="customer-name">
                              {customer.Party_Name}
                            </div>
                            <div className="customer-details">
                              <div className="customer-info">
                                <p>
                                  <strong>{customer.Party_Name}</strong>
                                </p>
                                <p>
                                  <strong>Location:</strong>{" "}
                                  {`${customer.City}, ${customer.State}`}
                                </p>
                                <p>
                                  <strong>Employee:</strong> {customer.Employee}
                                </p>
                              </div>
                              <div className="customer-sales">
                                <p>
                                  <strong>Avg Sale:</strong>{" "}
                                  {Math.round(customer.Avg_Sales)}/-
                                </p>
                                <p>
                                  <strong>Main Company:</strong>{" "}
                                  {customer.Company}
                                </p>
                              </div>
                              {pair.genericName2 && (
                                <div className="customer-actions">
                                  <button
                                    className="copy-request-btn"
                                    onClick={(e) => {
                                      e.stopPropagation(); // Also stop propagation here to prevent closing on button click
                                      copyMessageToClipboard(customer, pair);
                                    }}
                                  >
                                    Copy Request Order Message
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>
                        ))
                    ) : (
                      <p>No customers match this criteria.</p>
                    )}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
      {isPopupVisible && <div className="popup-message">{popupMessage}</div>}
    </div>
  );
};

export default ItemWiseReports;
